import { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ConferenceContext } from 'contexts/conference'
import { StandardButton } from 'components/buttons'
import { Icon, IconNames } from 'hello-design-system'

const NavButton: React.FC<{
    id?: string
    path: string
    text: string
    icon: IconNames
    disabled?: boolean
    onClick?: () => void
}> = ({ id, path, text, icon, disabled, onClick }) => {
    const conference = useContext(ConferenceContext)
    const location = useLocation()
    const navigate = useNavigate()
    const active = location.pathname === path && conference.status === 'session-joined'

    const navigateToPage = (): void => {
        navigate(path)
    }

    return (
        <StandardButton
            id={id}
            color={active ? 'primary' : 'secondary'}
            iconSrc={ <Icon iconName={icon} /> }
            onClick={onClick ?? navigateToPage}
            text={text}
            disabled={disabled}
        />
    )
}

export { NavButton }
